import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import type { ComputerStatus } from "@rakazo/contracts";

export function DesktopKindEmptyState({ className }: { className?: string }) {
  return (
    <div className={className}>
      <Trans>
        This bot runs on this computer, not a Linux desktop. Shell and files use your home folder.
      </Trans>
    </div>
  );
}

export function computerPlaceholder(
  state: ComputerStatus["state"] | undefined,
  booting: boolean,
  label: string,
) {
  if (state === "booting" || booting) return t`Booting live desktop…`;
  if (state === "running") return label;
  if (state === "suspended") return t`Computer is asleep. Open it to wake.`;
  if (state === "error") return t`Computer failed to boot`;
  return t`Computer is stopped`;
}

export function computerLabel(
  mode: ComputerStatus["mode"] | undefined,
  botName: string,
  computer?: Pick<ComputerStatus, "kind" | "deviceName"> | null,
) {
  if (computer?.kind === "desktop") return computer.deviceName || t`${botName}’s computer`;
  return mode === "dedicated" ? t`${botName}’s computer` : t`Team Computer`;
}
